//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    platforms: {
      type: Object,
      value: {}
    }
  },
  methods: {
    hide: function hide() {
      this.$emit('hide');
    },
    boxClick: function boxClick(event) {
      event.preventDefault();
    },
    touchmove: function touchmove(event) {
      event.preventDefault();
    },
    clickWeixin: function clickWeixin() {
      this.$emit('navi', {
        type: 'weixin'
      });
      this.hide();
    },
    clickMeituan: function clickMeituan() {
      this.$emit('navi', {
        type: 'meituan'
      });
      this.hide();
    },
    clickDianping: function clickDianping() {
      this.$emit('navi', {
        type: 'dianping'
      });
      this.hide();
    },
    clickMaoyan: function clickMaoyan() {
      this.$emit('navi', {
        type: 'maoyan'
      });
      this.hide();
    },
    clickGewara: function clickGewara() {
      this.$emit('navi', {
        type: 'gewara'
      });
      this.hide();
    }
  },
  mounted: function mounted() {
    this.$emit('mounted');
  }
};